"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearTokens = exports.clearLegacyToken = exports.clearToken = exports.getLegacyToken = exports.getToken = exports.setLegacyToken = exports.setToken = void 0;

var _config = require("../config");

const setToken = authResponse => {
  const {
    accessToken
  } = authResponse;
  const storageToken = {
    accessToken
  };
  localStorage.setItem((0, _config.storageKey)(), JSON.stringify(storageToken));
};

exports.setToken = setToken;

const setLegacyToken = (authResponse, opts = {}) => {
  const {
    isMagicLink = false
  } = opts;
  if (!authResponse.legacyAccessToken) return;
  const authenticator = isMagicLink ? 'authenticator:single-auth-affiliates' : 'authenticator:bkf-oauth2-customer';
  const {
    legacyAccessToken,
    expiresIn
  } = authResponse;
  const storageLegacyToken = {
    authenticated: {
      authenticator,
      [`access_token`]: legacyAccessToken,
      [`token_type`]: 'bearer',
      [`expires_in`]: expiresIn
    }
  };
  localStorage.setItem((0, _config.storageKeyLegacy)(), JSON.stringify(storageLegacyToken));
};

exports.setLegacyToken = setLegacyToken;

const getToken = () => {
  try {
    const {
      accessToken
    } = JSON.parse(localStorage.getItem((0, _config.storageKey)()));
    return accessToken;
  } catch (err) {
    return null;
  }
};

exports.getToken = getToken;

const getLegacyToken = () => {
  try {
    const {
      authenticated
    } = JSON.parse(localStorage.getItem((0, _config.storageKeyLegacy)()));
    return authenticated === null || authenticated === void 0 ? void 0 : authenticated.access_token;
  } catch (err) {
    return null;
  }
};

exports.getLegacyToken = getLegacyToken;

const clearToken = () => {
  try {
    localStorage.removeItem((0, _config.storageKey)());
  } catch (err) {
    throw new Error('Unable to remove accessToken from local storage');
  }
};

exports.clearToken = clearToken;

const clearLegacyToken = () => {
  try {
    localStorage.removeItem((0, _config.storageKeyLegacy)());
  } catch (err) {
    throw new Error('Unable to remove legacyAccessToken from local storage');
  }
};

exports.clearLegacyToken = clearLegacyToken;

const clearTokens = () => {
  clearToken();
  clearLegacyToken();
};

exports.clearTokens = clearTokens;